import { AppAreaConfig } from '@/funnels/@types'

import medGlpApp from './areas/glp-app'
import medGlpDm from './areas/glp-dm'
import medGlpUsa from './areas/glp-usa'
import medGlpAppV2 from './areas/glp-app-v2'

type FunnelGroup = {
	id: string
	name: string
	appAreas: AppAreaConfig[]
}

const FUNNEL_GROUPS: FunnelGroup[] = [
	{
		id: 'glp',
		name: 'GLP',
		// Дефолты от порядка не зависят (DEFAULT_AREA — из ENTRY_POINTS[0], пейвол-фоллбэк
		// захардкожен в funnelUtils); glp-app первым — просто конвенция «основная area выше».
		appAreas: [medGlpApp, medGlpDm, medGlpUsa, medGlpAppV2],
	},
]

export const APP_AREAS: AppAreaConfig[] = FUNNEL_GROUPS.flatMap((group) => group.appAreas)
